import { Endpoint } from "@eryxcoop/appyx-comm";
import DateAdapter from "../../../adapters/DateAdapter";

export default class SoldBoxesByCustomerAndArticleEndpoint extends Endpoint {
    adaptValues({ fromDate, toDate }) {
        const dateAdapter = new DateAdapter();
        return {
            from_date: dateAdapter.adapt(fromDate),
            to_date: dateAdapter.adapt(toDate),
        };
    }
}
